var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"floating-btn",style:({ 
    left: _vm.positionX + 'px',
    bottom: _vm.positionY + 'px'
  }),on:{"mousedown":_vm.startDrag,"touchstart":_vm.startDrag}},[_c('img',{staticStyle:{"width":"66px","height":"auto"},attrs:{"src":require("../assets/telegram.gif"),"alt":"懸浮按鈕"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }